import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100 transition";

  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-8 shadow-sm" data-testid="reset-page">
        <h1 className="font-display font-black text-slate-900 text-2xl">Set a new password</h1>
        {!token ? (
          <p className="text-red-600 mt-4">Missing or invalid reset token.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <input type="password" className={inputCls} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" data-testid="reset-password" />
            {error && <p className="text-sm text-red-600">{error}</p>}
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-green-600 px-6 py-3 font-bold text-white hover:bg-green-700 disabled:opacity-60" data-testid="reset-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Update password"}
            </button>
          </form>
        )}
        <Link to="/admin/login" className="mt-5 inline-block text-slate-500 hover:text-slate-700 text-sm">← Back to login</Link>
      </div>
    </div>
  );
}
